import { Trans } from '@lingui/macro'
import { ButtonRadioCheckedCenter } from 'components/Button'
import { RowBetween, RowCenter } from 'components/Row'
import { useState } from 'react'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { isMobile } from 'utils/userAgent'

import {
  FilterBadgeImg,
  FilterContainer,
  FilterContainerFinishBadge,
  FilterContainerItem,
  FilterContainerItemBadge,
} from '../style'
// import BaseBallIcon from './icons/baseball.svg'
import BasketballIcon from './icons/basketball.svg'
import ChampionsIcon from './icons/champions.svg'
import LaLigaIcon from './icons/laliga.svg'
/* import NBAIcon from './icons/nba.svg' */
import PremierIcon from './icons/premier.svg'
import SoccerIcon from './icons/soccer.svg'
import SoccerWhiteIcon from './icons/soccer_white.svg'
import WhistleIcon from './icons/whistle.svg'
/* import WorldCupIcon from './icons/worldcup.svg' */
// import TennisIcon from './icons/tennis.svg'

const ButtonChecked = styled(ButtonRadioCheckedCenter)`
  height: 2.5em;
  margin: auto;
  border-radius: 20px;
  border-color: ${({ theme }) => theme.primary1};
`

export enum ESportType {
  SOCCER,
  BASKETBALL,
  TENNIS,
  BASEBALL,
}

interface ISportCategoryItem {
  name: string
  sportIds: number
  ico: string
}

export interface ISportCategory {
  [ESportType.SOCCER]: ISportCategoryItem[]
  [ESportType.BASKETBALL]: ISportCategoryItem[]
  [ESportType.TENNIS]: ISportCategoryItem[]
  [ESportType.BASEBALL]: ISportCategoryItem[]
}

const sports = [
  { name: 'Soccer', type: ESportType.SOCCER, ico: SoccerIcon },
  { name: 'Basketball', type: ESportType.BASKETBALL, ico: BasketballIcon },
  // { name: 'Tennis', type: ESportType.TENNIS, ico: TennisIcon },
  // { name: 'Baseball', type: ESportType.BASEBALL, ico: BaseBallIcon },
]

const sportsCategory: ISportCategory = {
  [ESportType.SOCCER]: [
    { name: 'UEFA Champions League', sportIds: 16, ico: ChampionsIcon },
    /* { name: 'Mundial Qatar', sportIds: 17, ico: WorldCupIcon }, */
    /* { name: "NCAA Men's Football", sportIds: 1 }, */
    /* { name: 'Ligue 1', sportIds: 12 },
    { name: 'Bundesliga', sportIds: 13 }, */
    { name: 'La Liga', sportIds: 14, ico: LaLigaIcon },
    { name: 'Premier League', sportIds: 11, ico: PremierIcon },
    /* { name: 'Serie A', sportIds: 15 },
    { name: 'MLS', sportIds: 10 }, */
  ],
  [ESportType.BASKETBALL]: [
    /* { name: 'MLB', sportIds: 3 }, */
    /* { name: 'NBA', sportIds: 4, ico: NBAIcon }, */
    /* { name: "NCAA Men's Basketball", sportIds: 5 },
    { name: 'WNBA', sportIds: 8 }, */
  ],
  [ESportType.TENNIS]: [],
  [ESportType.BASEBALL]: [],
}

const league = [
  { name: 'UEFA Champions League', sportIds: 16, ico: ChampionsIcon },
  { name: 'La Liga', sportIds: 14, ico: LaLigaIcon },
  { name: 'Premier League', sportIds: 11, ico: PremierIcon },
]

interface FilterProps {
  onChangeSport: (sportId?: number) => void
  onShowFinished: (show: boolean) => void
}

function Filter({ onChangeSport, onShowFinished }: FilterProps) {
  const [isDark] = useDarkModeManager()
  /* const [sportTypeSelected, setSportTypeSelected] = useState<ESportType | undefined>()
  const [sportCategorySelected, setSportCategorySelected] = useState<ISportCategoryItem[]>([]) */
  const [sportId, setSportId] = useState<number | undefined>()
  const [showFinished, setShowFinished] = useState(false)

  const handleShowFinished = () => {
    onShowFinished(!showFinished)
    setShowFinished(!showFinished)
  }

  /*  const setSportType = (key: ESportType) => {
    if (key === undefined) return
    if (key === sportTypeSelected) {
      setSportTypeSelected(undefined)
      setSportCategorySelected([])
      setSportId(undefined)
      onChangeSport(undefined)
      return
    }
    setSportTypeSelected(key)
    const filterSportsCategory = sportsCategory[key]
    setSportCategorySelected(filterSportsCategory)
  } */

  const setSport = (sport?: number) => {
    setSportId(sport)
    onChangeSport(sport)
  }

  return (
    <FilterContainer>
      {/* <FilterContainerItem>
        {sports.map((item, key) => (
          <FilterBadge
            key={'filter_badge_' + item.type}
            isSelected={sportTypeSelected === key}
            onClick={() => setSportType(item.type)}
          >
            <FilterBadgeImg src={item.ico} alt="" />
            {item.name}
          </FilterBadge>
        ))}
      </FilterContainerItem> */}
      {isMobile && (
        <RowCenter>
          <FilterContainerItemBadge isSelected={sportId === undefined} onClick={() => setSport(undefined)}>
            <FilterBadgeImg src={SoccerWhiteIcon} alt="" />
            <ThemedText.Body color="#fff">
              <Trans>All</Trans>
            </ThemedText.Body>
          </FilterContainerItemBadge>
          <FilterContainerFinishBadge isMobile={isMobile} isSelected={showFinished} onClick={handleShowFinished}>
            <FilterBadgeImg src={WhistleIcon} alt="" />
            <ThemedText.Body color="#fff">
              <Trans>Show Finished</Trans>
            </ThemedText.Body>
          </FilterContainerFinishBadge>
        </RowCenter>
      )}
      <RowBetween>
        <FilterContainerItem isMobile={isMobile}>
          {!isMobile && (
            <FilterContainerItemBadge isSelected={sportId === undefined} onClick={() => setSport(undefined)}>
              <FilterBadgeImg src={SoccerWhiteIcon} alt="" />
              <ThemedText.Body color="#fff">
                <Trans>All</Trans>
              </ThemedText.Body>
            </FilterContainerItemBadge>
          )}
          {league.map((item: ISportCategoryItem) => (
            <FilterContainerItemBadge
              key={'sport_category_' + item.sportIds}
              onClick={() => setSport(item.sportIds)}
              isSelected={item.sportIds === sportId}
            >
              <img
                width="64px"
                src={
                  isDark
                    ? `${process.env.PUBLIC_URL}/images/sports/leagues/${item.sportIds}_White.png`
                    : `${process.env.PUBLIC_URL}/images/sports/leagues/${item.sportIds}.png`
                }
                alt=""
              />
            </FilterContainerItemBadge>
          ))}
        </FilterContainerItem>
        {!isMobile && (
          <FilterContainerFinishBadge
            isMobile={isMobile}
            isSelected={showFinished}
            onClick={handleShowFinished}
            style={{ marginRight: '1.5rem' }}
          >
            <FilterBadgeImg src={WhistleIcon} alt="" />
            <ThemedText.Body color="#fff">
              <Trans>Show Finished</Trans>
            </ThemedText.Body>
          </FilterContainerFinishBadge>
        )}
      </RowBetween>
    </FilterContainer>
  )
}

export default Filter
